function FilterByField({ title, filters, setFilters, filterFields }) {
  const operatorsByType = {
    text: [
      { value: "is", label: "Is" },
      { value: "contains", label: "Contains" },
      { value: "startsWith", label: "Starts With" },
      { value: "endsWith", label: "Ends With" },
      { value: "isNot", label: "Is Not" },
    ],
    number: [
      { value: "equals", label: "Equals" },
      { value: "greaterThan", label: "Greater Than" },
      { value: "lessThan", label: "Less Than" },
      { value: "notEqual", label: "Not Equal" },
    ],
    date: [
      { value: "is", label: "Is" },
      { value: "before", label: "Before" },
      { value: "after", label: "After" },
      { value: "not", label: "Not" },
    ],
    // Add more types and operators as needed
  };

  const handleFieldChange = (index, event) => {
    const newFilters = JSON.parse(JSON.stringify([...filters]));
    newFilters[index].field = event.target.value;

    // if (index === filters.length - 1) {
    //   setFilters([
    //     ...newFilters,
    //     { field: "", operator: "", value: "", type: "" },
    //   ]);
    // } else {
    setFilters(newFilters);
    // }
  };

  const handleOperatorChange = (index, event) => {
    const newFilters = JSON.parse(JSON.stringify([...filters]));
    newFilters[index].operator = event.target.value;
    setFilters(newFilters);
  };

  const handleValueChange = (index, event) => {
    const newFilters = JSON.parse(JSON.stringify([...filters]));
    newFilters[index].value = event.target.value;
    setFilters(newFilters);
  };

  const handleTypeChange = (index, event) => {
    const newFilters = JSON.parse(JSON.stringify([...filters]));
    newFilters[index].type = event.target.value;
    setFilters(newFilters);
  };

  const handleRemoveFilter = (index) => {
    // if (filters.length == 1) return;
    const newFilters = filters.filter((_, i) => i !== index);
    setFilters(newFilters);
  };
  return (
    <>
      <div className="filter-table custom-scroll">
        <ul>
          {filters.map((filter, index) => (
            <li className="d-flex" key={index}>
              <div className="col1">
                <span className="number">{index + 1}.</span>
              </div>
              <div className="coll col3">
                <select
                  className="form-control"
                  value={filter.field}
                  onChange={(event) => handleFieldChange(index, event)}
                >
                  <option value="">Select field</option>
                  <optgroup label={title}>
                    {filterFields.map((field, index) => (
                      <option
                        key={index}
                        value={typeof field == typeof "" ? field : field.id}
                      >
                        {typeof field == typeof ""
                          ? field.replace(/\./g, "/")
                          : field.name.replace(/\./g, "/")}
                      </option>
                    ))}
                  </optgroup>
                </select>
              </div>
              <div className="coll col3">
                <select
                  className="form-control capitalize"
                  value={filter.type}
                  onChange={(event) => handleTypeChange(index, event)}
                >
                  <option value="">Select type</option>
                  {Object.keys(operatorsByType).map((opType, key) => (
                    <option value={opType} key={key} className="capitalize">
                      {opType}
                    </option>
                  ))}
                  {/* <option value="text">Text</option>
                  <option value="number">Number</option>
                  <option value="date">Date</option> */}
                </select>
              </div>
              <div className="coll col3">
                <select
                  className="form-control"
                  value={filter.operator}
                  onChange={(event) => handleOperatorChange(index, event)}
                >
                  <option value=""></option>

                  {filter?.type ? (
                    filter.field == "Id" ? (
                      <option value={"is"}>{"Is"}</option>
                    ) : (
                      operatorsByType[filter.type].map((op, key) => (
                        <option value={op.value}>{op.label}</option>
                      ))
                    )
                  ) : null}

                  {/* <option value="equals">equals</option>
                  <option value="not equal to">not equal to</option>
                  <option value="less than">less than</option>
                  <option value="greater than">greater than</option>
                  <option value="less or equal">less or equal</option>
                  <option value="greater or equal">greater or equal</option> */}
                </select>
              </div>
              <div className="coll col3">
                <input
                  className="form-control"
                  placeholder="Enter Value"
                  value={filter.value}
                  type={filter?.type === "date" ? "date" : "text"}
                  onChange={(event) => handleValueChange(index, event)}
                />
              </div>
              <div className="col6">
                <a
                  className="closed-filter"
                  href="javascript:void(0)"
                  onClick={() => handleRemoveFilter(index)}
                  title="Remove this"
                ></a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default FilterByField;
